<template>
  <div>
    <section class="client-listing-area">
      <div class="client-listing-head-fluid" style="padding-bottom: 5px;">
        <div class="container">
          <div class="client-listing-head">
            <UnderReviewSearchBar />
          </div>
        </div>
      </div>
      <div class="client-listing-detail-fluid">
        <div class="container px-0">
          <div class="client-listing-detail">
            <UnderReviewList />
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
import UnderReviewList from '@/components/dashboard/applicants/UnderReviewList.vue';
import UnderReviewSearchBar from '@/components/dashboard/applicants/UnderReviewSearchBar.vue';
import { mapMutations } from 'vuex';

export default {
  name: 'UnderReview',
  components: { UnderReviewSearchBar, UnderReviewList },
  mounted() {
    this.changeBodyBackground();
  },
  methods: {
    ...mapMutations({
      resetApplicantListState: 'resetApplicantListState',
      setSelectedReviewListIds: 'setSelectedReviewListIds',
    }),
  },
  beforeRouteLeave(to, from, next) {
    this.resetApplicantListState();
    this.setSelectedReviewListIds([]);
    next();
  },
};
</script>
